import React, { useRef } from "react";

import { Container, TextBox1 } from "./style";
import { useTranslation } from "react-i18next";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com1 = () => {
  const { t } = useTranslation("howToGetSketch");
  const navHandler = () => {
    window.open("https://www.probit.com/en-us/");
  };
  const ref1 = useRef();
  useScrollFadeIn(ref1);
  return (
    <Container>
      <TextBox1>
        <div>
          <span>{t("1-1")}</span>
          <span>{t("1-1-1")}</span>
        </div>
        <span>{t("1-2")}</span>
        <span>{t("1-3")}</span>

        <div onClick={navHandler}>{t("1-4")}</div>
      </TextBox1>
      <img
        loading="lazy"
        src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/4c0be0c9HowToGetSKET_1.svg"
        alt="coin_cart_img"
        ref={ref1}
        className="fade-in"
      />
    </Container>
  );
};

export default Com1;
